import $ from "jquery";
import {commentHandler, partnerHandler} from "./dataLayer/data-layer-metrica-handlers";

let timer = null;
const partnerViewedMap = {};
const commentViewedMap = {};

export const scrollHandlers = () => {
    clearTimeout(timer);

    timer = setTimeout(function () {
        checkPartnerView();
        checkCommentView();

    }, 100);
};
const checkPartnerView = () => {
    $('.partners-widget.partners-widget--longread').each(function () {
        const materialId = $(this).parents('.material-content__parts-wrapper').data('id');

        if (partnerViewedMap[materialId] !== undefined) {
            return;
        }

        if (!isInView($(this))) {
            return;
        }

        partnerViewedMap[materialId] = true;

        partnerHandler();
    });
};
const checkCommentView = () => {
    $('.comment-replies').each(function () {
        const materialId = $(this).parents('.material-content__parts-wrapper').data('id');

        if (commentViewedMap[materialId] !== undefined) {
            return;
        }

        if (!isInView($(this))) {
            return;
        }

        commentViewedMap[materialId] = true;

        commentHandler();
    });
};
const isInView = (object) => {
    if (object.offset().top > $(window).height() + $(window).scrollTop()) {
        return false;
    }

    return object.offset().top >= $(window).scrollTop();
};
